<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="6">
          <v-btn
                color="secondary"
                outlined
                class="mr-1"
                :to="'/partner/reports/customer/' + companyid + '/course'"
              >
                <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to
                Reports
              </v-btn>
        </v-col>
        <v-col md="12">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-text-field
                class="search-box"
                placeholder="Search Users"
                prepend-icon="fa-search"
                v-model="search"
                type="text"
                clearable
                clear-icon="fa-times"
                @click:clear="resetSearch"
                @change="applySearch"
              ></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-title>
              <div class="flex-grow-1"></div>
            </v-card-title>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="users"
              :footer-props="{
                'items-per-page-options': [5, 10, 15],
              }"
            >
              <template
                v-slot:item.usercourses.last_completed_event_date="{ item }"
              >
                {{ item.usercourses.last_completed_event_date }}
              </template>
              <template v-slot:item.usercourses.progress="{ item }">
                {{ item.usercourses.progress }}%
                <!--<v-progress-linear
                  v-if="item.usercourses.state == 1"
                  :value="item.usercourses.progress"
                  color="success"
                  height="20"
                ></v-progress-linear>
                <v-progress-linear
                  v-else-if="item.usercourses.state == 2"
                  :value="item.usercourses.progress"
                  color="success"
                  height="20"
                ></v-progress-linear>
                <v-progress-linear
                  v-else-if="item.usercourses.state == 5"
                  :value="item.usercourses.progress"
                  color="success"
                  height="20"
                ></v-progress-linear>
                <v-progress-linear
                  v-else-if="item.usercourses.state == 3"
                  :value="item.usercourses.progress"
                  color="success"
                  height="20"
                ></v-progress-linear> -->
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import userAPI from '@/api/user.js';
import courseAPI from '@/api/course.js';
import LayoutBasic from '@/layouts/Dashboard';
export default {
  name: 'CourseDetailsReport',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Surname', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'Enrolled Date', value: 'usercourses.enrolled_date_formatted' },
        { text: 'Deadline', value: 'usercourses.deadline_formatted' },
        { text: 'Started Date', value: 'usercourses.start_date_formatted' },
        {
          text: 'Date Completed',
          value: 'usercourses.complete_date_formatted',
        },
        { text: 'Last Accessed', value: 'usercourses.last_accessed_date' },

        { text: 'Progress', value: 'usercourses.progress' },
        { text: 'Test Score', value: 'usercourses.test_score' },
        { text: 'Attempts', value: 'usercourses.attempts' },
        { text: 'Agree Status', value: 'usercourses.is_agree' },
        { text: 'Agreed By', value: 'usercourses.signed_name' },
      ],
      id: this.$route.params.courseid,
      companyid: this.$route.params.id,
      users: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
    };
  },
  computed: {
    serverItemsLength: function() {
      return this.pagination.total;
    },
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return (
        this.$gf.getQueryString(this.options, this.serverItemsLength) +
        this.searchParams +
        '&include='
      );
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getEnrolledUsers();
      },
      deep: true,
    },
  },
  methods: {
    getEnrolledUsers() {
      this.loading = true;
      courseAPI
        .getcompanyCourseEnrolledUsers(
          this.id,
          this.companyid,
          this.params + 'usercourses'
        )
        .then((resp) => {
          this.users = [];
          resp.data.data.forEach((item) => {
            item.usercourses = item.usercourses.data.filter((userCourse) => {
              return userCourse.course_id == this.id;
            });
            item.usercourses = item.usercourses[0];
            this.users.push(item);
          });
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    resetSearch() {
      this.options.page = 1;
      this.searchParams = '';
      this.search = '';
      this.applySearch();
    },
    applySearch() {
      this.options.page = 1;
      if (this.search != null) {
        this.searchParams =
          this.params +
          '&search=first_name:' +
          this.search +
          ';last_name:' +
          this.search;
      }
      this.getEnrolledUsers();
    },
  },
};
</script>
